module.exports = __webpack_public_path__ + "img/icons-top.b5eeb6c5.svg";